<template>
  <div class="mibile-wrapper">
    <Home-Header :navindex="0"></Home-Header>
    <!-- <div class="demo-image__preview">
        <el-image style="width: 100%; height: auto"
          :src="srcList"
          :preview-src-list="banner_img">
        </el-image>
      </div> -->
    <div class="swiper-bg" >
      <div class="change">点击切换清卡</div>
      <el-carousel  trigger="click" :height="swiperHeight + 'px'" arrow="always" :autoplay="false">
        <el-carousel-item v-for="item in banner_img" :key="item.index">
          <el-image :src="item.img" fit="fill" ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import '../../assets/css/mstyle.css'
import HomeHeader from '../mcommon/Header'
import HomeTabBar from '../mcommon/TabBar'
import HomeSwiper from '../mcommon/Swiper'
export default {
  name: 'Tax',
  metaInfo: {
    // 这里的 title 会替换 title中的字符占位
    title: '抄税-上海机巧科技有限公司'
  },
  components: {
    HomeHeader, HomeTabBar, HomeSwiper
  },
  data () {
    return {
      banner_img: [ {
        img: require('../../assets/mimage/mTax-03.png')
      }, {
        img: require('../../assets/mimage/mTax-02.png')
      }, {
        img: require('../../assets/mimage/mTax-01.png')
      }],
      screenWidth: document.body.clientWidth, // 屏幕尺寸
      swiperHeight: 180
    }
  },
  props: {
    slideindex: Number
  },
  created () {
  },
  computed: {
  },
  mounted () {
    const that = this
    that.screenWidth = document.body.clientWidth
    that.swiperHeight = that.screenWidth / (674 / 2377)
    // window.onresize = () => {
    //   return (() => {
    //     window.screenWidth = document.body.clientWidth
    //     that.screenWidth = window.screenWidth
    //     console.log(that.screenWidth, 'that.screenWidth')
    //     that.swiperHeight = that.screenWidth / (674 / 315)
    //     console.log(that.swiperHeight, 'that.swiperHeight')
    //   })()
    // }
  }
}
</script>

<style scoped>
.content-wrapper{
  margin-top: 72px;
}
hr{
  height: 10px;
  width: 100%;
  background: #f8f6f9;
}
.swiper-bg{
   background: #2d50ff;
}
.swiper-bg .el-carousel__arrow{
  top: 10%!important;

}
.change{
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  padding: 35px auto;
  text-align: center;
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mhome/MTax.vue